import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white text-gray-600 border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 flex items-center justify-center">
                <i className="fas fa-briefcase text-white text-sm"></i>
              </div>
              <span className="text-xl font-bold font-lexend text-gray-900">CareerFlow.io</span>
            </Link>
            <p className="text-gray-500 text-sm mb-6 leading-relaxed">
              Your all-in-one career ecosystem. Build resumes, track jobs, and ace interviews with AI-powered tools.
            </p>
            <div className="flex space-x-4">
              <a href="https://x.com/KrSUVII21" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-cyan-500 hover:text-white transition-all duration-300">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://www.linkedin.com/in/kritika-gupta2106/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-blue-600 hover:text-white transition-all duration-300">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://github.com/ksuvii21" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-gray-800 hover:text-white transition-all duration-300">
                <i className="fab fa-github"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">Platform</h3>
            <ul className="space-y-3 text-sm text-gray-500">
              <li><Link to="/" className="hover:text-cyan-600 transition-colors">Home</Link></li>
              <li><Link to="/builder" className="hover:text-cyan-600 transition-colors">Resume Builder</Link></li>
              <li><Link to="/cover-letter" className="hover:text-cyan-600 transition-colors">Cover Letter AI</Link></li>
              <li><Link to="/tracker" className="hover:text-cyan-600 transition-colors">Job Tracker</Link></li>
              <li><Link to="/analytics" className="hover:text-cyan-600 transition-colors">Analytics</Link></li>
              <li><Link to="/smart-jobs" className="hover:text-cyan-600 transition-colors">Smart Job Manager</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">Resources</h3>
            <ul className="space-y-3 text-sm text-gray-500">
              <li><Link to="/interview/mock" className="hover:text-cyan-600 transition-colors">Mock Interviews</Link></li>
              <li><Link to="/salary" className="hover:text-cyan-600 transition-colors">Salary Insights</Link></li>
              <li><Link to="/interview/prep" className="hover:text-cyan-600 transition-colors">Prep Notes</Link></li>
              <li><Link to="/community" className="hover:text-cyan-600 transition-colors">Community</Link></li>
              <li><Link to="/ai-assistants" className="hover:text-cyan-600 transition-colors">AI Tools</Link></li>
              <li><Link to="skill-assessment" className="hover:text-cyan-600 transition-colors">Skill Assessment</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">Support</h3>
            <ul className="space-y-3 text-sm text-gray-500">
              <li><Link to="/contact" className="hover:text-cyan-600 transition-colors">Contact Us</Link></li>
              <li><Link to="/privacy" className="hover:text-cyan-600 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-cyan-600 transition-colors">Terms of Service</Link></li>
              <li><Link to="/upgrade" className="hover:text-cyan-600 transition-colors">Upgrade Plan</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} CareerFlow.io. All rights reserved.
          </p>
          <p className="text-gray-600 text-sm mt-2 md:mt-0 flex items-center">
            Designed & Developed by <span className="text-gray-800 font-medium ml-1">Kritika Gupta</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;